export default function LoaderReviewersDetails() {
    return (
        <div className="flex flex-col gap-2">
            <div className="h-[500px] animate-pulse rounded-md border-2 border-muted bg-white p-4"></div>
        </div>
    )
}
